<style lang='stylus'scoped>
active = #336db0;

.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: active;

  &::after {
    background: @color;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  // display: flex;
  // flex-direction: column;
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}

.block {
  // width: fit-content;
  // margin-left: auto;
  // margin-right: auto;
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>

<template>
  <div>
    <div class="carWrap">
      <exportDate v-if="showExport" @hideExport="hideExport1" :tab="tab" :moduleName="moduleName"/>
      <div class="header">
        <TitleHeader :titleArr="titleArr" :changeTab="changeTab" :tab="tab"/>
        <div class="righth">
          <span class="demonstration">统计月份</span>
          <el-date-picker
            v-model="monTime"
            type="month"
            placeholder="选择月"
            @change="changeTime"
            value-format="yyyy-MM"
          ></el-date-picker>
          <el-button v-show="hideExport" style="margin-left:15px;" @click="exportDate">导出</el-button>
        </div>
      </div>
      <main>
        <StopTable :allData="allData" v-if="tab === 0" :index="indexAll" :toDetail="toDetail"></StopTable>
        <TimeTable :allData="allData" v-else :index="indexAll" :toDetail="toDetail"></TimeTable>
      </main>
      <div class="block" style>
        <el-pagination
          @current-change="changeData"
          :current-page.sync="index"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          slot="pagin"
          style="margin:auto;"
        ></el-pagination>
      </div>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1、行驶车辆数：在该高速上行驶过的货运平台车辆数总和；</div>
      <div>2、运营里程：货运平台车辆在该高速上行驶里程总和；</div>
      <div>3、停靠小计：货运平台车辆在该高速上所有油站的停靠次数总和，各品牌油站停靠统计同此规则；</div>
      <div>4、运营车次小计：每辆车每天在该高速上运营过记一次（辆）；</div>
      <div>5、各时间段运营车次：每辆车每天该时间段在该高速上运营过记1次（辆）；</div>
      <div>6、注册省：本省在货运平台登记入网的车辆数。</div>
    </div>
  </div>
</template>
<script>
import StopTable from './components/stopTable' // 高速加油站停靠表格
import TimeTable from './components/timeTable' // 高速运营时段表格
import TitleHeader from './components/titleHeader' // title表格
import TimeHeader from './components/timeHeader'
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
import { hideExport } from '@/utils/tools'
var now = new Date()
now.setMonth(now.getMonth() - 1)
export default {
  components: {
    StopTable,
    TimeTable,
    TitleHeader,
    TimeHeader
  },
  data() {
    return {
      hideExport:hideExport,
      moduleName: 'operateCollectionStat',
      showExport: false, //控制批量导出
      titleArr: ['高速加油站停靠统计', '高速运营时段统计'],
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      monTime: now,
      total: 0, // 总页数
      allData: [], // 总数据
      index: 1, // 当前页数
      endMonth: '', //请求日期
      pageSize: 20,
      indexAll: 0
    }
  },
  created() {
    let type = this.$route.query.type
    this.tab = type ? type : 0
  },
  mounted() {
    let that = this
    let time = that.monTime
    let year = time.getFullYear()
    let month = time.getMonth()
    that.endMonth = year + that.initMonth(month)
    this.initData()
  },
  methods: {
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    initData(num = 0) {
      let that = this
      http
        .carOperate({
          page: that.index,
          pageSize: that.pageSize,
          countTime: that.endMonth,
          firstIs: num
        })
        .then(e => {
          if (e.data && e.data.tPageUtil && e.data.tPageUtil.list) {
            that.allData = [...e.data.tPageUtil.list]
            that.total = e.data.tPageUtil.count
            that.monTime = e.data.time
            let time = e.data.time
            that.endMonth = time.replace('-', '')
          } else {
            that.allData = []
            that.total = 0
          }
        })
    },
    changeData(index) {
      let that = this
      that.index = index
      that.initData(1)
      that.indexAll = that.pageSize * (index - 1)
    },
    changeTab(index) {
      let that = this
      that.tab = index
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.index = 1
      that.endMonth = arr[0] + '' + arr[1]
      that.initData(1)
    },
    exportDate() {
      this.showExport = true
    },
    toDetail(item) {
      this.$router.push({
        name: 'carOpeDetail',
        query: {
          type: this.tab,
          roadCode: item,
          endMonth: this.endMonth
        }
      })
    }
  }
}
</script>